import React from "react";
import classNames from "classnames";
import useDarkMode from "../../../hooks/useDarkMode";
import Footer from "../../../layout/Footer/Footer";
import ProeffectiveLogo from "../../../assets/img/Proeffective_logo.jpeg";
// import vYuLogo from "../../../assets/logos/vyuLogo.jpeg";
// import vYuLogo from "../../../assets/logos/vyu.png";
// import vYuLogo from "../../../assets/logos/vyu3.jpeg";
import vYuLogo from "../../../assets/logos/vyu4.jpeg";

const DefaultFooter = () => {
  const { darkModeStatus } = useDarkMode();

  return (
    <Footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <span className="copyright-text">Copyright © 2024</span>
          </div>
          <div className="col"></div>
          <div className="col-auto">
            {/* <a
              href="/"
              className={classNames("text-decoration-none", {
                "link-dark": !darkModeStatus,
                "link-light": darkModeStatus,
              })}
            >
              <small className="fw-bold">Proeffective </small>
            </a> */}
            {/* <svg
              width="80.74941451990632"
              height="32"
              viewBox="0 0 1 900"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="300"
                width="256"
                height="256"
                rx="64"
                fill="#46BCAA"
              ></rect>
              <circle cx="128" cy="726" r="128" fill="#4D69FA"></circle>
              <rect
                x="300"
                y="355"
                width="256"
                height="144"
                fill="#6C5DD3"
              ></rect>
              <path
                d="M128 24L238.851 216H17.1488L128 24Z"
                fill="#FFCF52"
              ></path>
              <path
                d="M128 307L238.851 367.197V487.59L128 547.787L17.1488 487.59V367.197L128 307Z"
                fill="#F35421"
              ></path>
            </svg> */}
            <img
              src={vYuLogo}
              alt="Proeffective Logo"
              className="proeffective-logo"
            />
            {/* <span className="vyu-text">vYu</span> */}
            <img
              src={ProeffectiveLogo}
              alt="Proeffective Logo"
              className="proeffective-logo"
            />
          </div>
        </div>
      </div>
    </Footer>
  );
};

export default DefaultFooter;
